import React from 'react';
import { ToastProvider } from '@aptuno/aptuno-ui';


const Providers = ({ children }) => {
  return <ToastProvider variant="top_rigth">{children}</ToastProvider>;
};

export default Providers;
